<template>
  <v-content class="pa-12">
    <v-layout justify-space-around>
      <v-flex d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
        <span>งานวิจัยใหม่</span>
      </v-flex>
    </v-layout>

    <v-layout my-6>
      <v-flex xs4 mr-12>
        <v-autocomplete placeholder="ค้นหาประเภทการส่ง" background-color="#FBF6F3" clearable :items="items"
          item-text="name" item-value="name" outlined dense color="#3E7662" hide-details v-model="typeSending"
          @change="onChangeTypeSend('typeSending', $event)"></v-autocomplete>
      </v-flex>
      <v-flex xs4>
        <v-text-field placeholder="ชื่อโครงการวิจัย" color="#3e7662" dense outlined v-model="researchName" hide-details
          @change="onChangeTypeSend('researchName', $event)" />
      </v-flex>
      <v-flex xs1>
        <v-btn color="#3e7662" dark @click="search(1)">
          <span class="font-weight-bold">ค้นหา</span>
        </v-btn>
      </v-flex>
    </v-layout>
    <!-- Table -->
    <v-layout>
      <v-flex>
        <form-table :headers="headers" :items="researchList" onViewData></form-table>
      </v-flex>
    </v-layout>
    <!-- Pagination -->
    <v-layout mt-12>
      <v-flex>
        <v-pagination color="#3E7662" :length="paginateResearch.last_page" :total-visible="9"
          @input="getNewResearchList" v-model="paginateResearch.current_page"></v-pagination>
      </v-flex>
    </v-layout>
    <loading color="#527281" :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
  </v-content>
</template>

<script>
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import FormTable from "../../components/table/FormTable";
import { mapState, mapActions } from "vuex";
import AuthService from "../../services/AuthService";

export default {
  components: {
    FormTable,
    Loading,
  },
  data: () => ({
    paginateResearch: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 1,
      total: 1,
      to: 1,
    },
    headers: [
      {
        text: "ลำดับ",
        value: "number",
        align: "center",
        sortable: false,
        class: "header-data-table",
      },
      {
        text: "ชื่องานวิจัย",
        value: "researchName",
        align: "center",
        sortable: false,
      },
      {
        text: "ชื่อผู้วิจัย",
        value: "researcherName",
        align: "center",
        sortable: false,
      },
      { text: "สถานะ", value: "status", align: "center", sortable: false },
      {
        text: "สถานะการแก้ไข",
        value: "editStatus",
        align: "center",
        sortable: false,
      },
      {
        text: "เลขรับ (Initial)",
        value: "initial",
        align: "center",
        sortable: false,
      },
      {
        text: "ประเภทการส่ง",
        value: "submissionType",
        align: "center",
        sortable: false,
      },
      {
        text: "วันที่ส่ง",
        value: "sendDate",
        align: "center",
        sortable: false,
      },
      { text: "ตรวจสอบ", value: "check", align: "center", sortable: false },
      { text: "ดูโครงร่าง", value: "view", align: "center", sortable: false },
    ],

    isLoading: false,
    fullPage: true,
    researchList: [],
    typeSending: "0",
    researchName: "",
    items: [
      { id: "0", name: "ทั้งหมด" },
      { id: "1", name: "Initial Submission" },
      { id: "2", name: "Re Submission(Manual)" },
      { id: "3", name: "Re Submission" },
    ],
  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
      role: (state) => state.Auth.role,
    }),
  },
  created() {
    // Check Permission Access
    if (this.role !== 1 && this.role !== 4) {
      this.$router.go(-1);
    }
    this.getNewResearchList(1);
  },
  methods: {
    getNewResearchList(page) {
      this.isLoading = true;
      this.researchList = [];
      this.$store
        .dispatch("Research/getNewResearchList", page)
        .then((res) => {
          let i = 1;
          let affiliation = '';
          res.data.forEach((value) => {
            if (value.user.affiliation) {
              if (value.user.affiliation.affiliation === 'อื่นๆ')
                affiliation = value.user.otherAffiliation
              else
                affiliation = value.user.affiliation.affiliation
            }
            this.researchList.push({
              number: i,
              researchName: value.thResearchName,
              researcherName: value.user.preNameTh ? value.user.preNameTh + " " + value.user.thName : value.user.thName,
              researcherMobile: value.user.mobilePhone,
              researcherAffiliation: affiliation,
              coordinatorName: (value.coordinator === "-" || value.coordinator === null) ? "-" : value.coordinator.preNameTh ? value.coordinator.preNameTh + " " + value.coordinator.thName : value.coordinator.thName,
              coordinatorMobile: (value.coordinator === "-" || value.coordinator === null) ? "-" : value.coordinator.mobilePhone,
              status: value.status,
              initial: value.initialNumber ? value.initialNumber : "-",
              submissionType: value.submissionType ? value.submissionType : "-",
              sendDate: value.sendDate ? value.sendDate : "-",
              editStatus: value.editStatus ? value.editStatus : "-",
              approvalResult: value.approvalResult ? value.approvalResult : "-",
              id: value.id,
              linkView: "FormResearch1",
              form: "NewResearch",
              linkCheck: "ResearchVerify",
              onView: 11,
            });
            i++;
          });
          this.paginateResearch.current_page = res.current_page;
          this.paginateResearch.from = res.from;
          this.paginateResearch.last_page = res.last_page;
          this.paginateResearch.per_page = res.per_page;
          this.paginateResearch.total = res.total;
          this.paginateResearch.to = res.to;
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);

      sub_year = parseInt(sub_year) + 543;

      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    async onChangeTypeSend(name, e) {

      this.researchList = [];
      var oldStatus = '';
      var researchName = "";
      if (e !== 'ทั้งหมด') {
        oldStatus = e;
      }
      if (name == "researchName") {
        researchName = e;
      }
      this.isLoading = true;
      await AuthService.get(`/api/show-paginate-new-research?oldStatus=${oldStatus}&researchName=${researchName}`).then((res) => {
        let i = 1;
        res.research.data.forEach((data) => {
          this.researchList.push({
            number: i,
            researchName: data.thResearchName,
            researcherName:
              data.user.preNameTh ? data.user.preNameTh + " " + data.user.thName : data.user.thName,
            researcherMobile: data.user.mobilePhone,
            researcherAffiliation: data.user.affiliation.affiliation,
            coordinatorName:
              data.coordinator === "-"
                ? "-"
                : data.coordinator.preNameTh ? data.coordinator.preNameTh +
                  " " +
                  data.coordinator.thName : data.coordinator.thName,
            coordinatorMobile:
              data.coordinator === "-" ? "-" : data.coordinator.mobilePhone,
            status: data.status,
            initial: data.initialNumber ? data.initialNumber : "-",
            submissionType: data.submissionType ? data.submissionType : "-",
            editStatus: data.editStatus ? data.editStatus : "-",
            approvalResult: data.approvalResult ? data.approvalResult : "-",
            id: data.id,
            linkView: "FormResearch1",
            form: "NewResearch",
            linkCheck: "ResearchVerify",
            onView: 11,
          });
          i++;
        });
        this.paginateResearch.current_page = res.research.current_page;
        this.paginateResearch.from = res.research.from;
        this.paginateResearch.last_page = res.research.last_page;
        this.paginateResearch.per_page = res.research.per_page;
        this.paginateResearch.total = res.research.total;
        this.paginateResearch.to = res.research.to;
        this.isLoading = false;
      })
        .catch((e) => {
          console.log('error', e);
          this.isLoading = false;
        });
    },
    search(page) {
      console.log(page);
    }
  },
};
</script>

<style lang="scss">
.header-data-table {
  font-size: 20px;
}
</style>
